import { Directive, HostBinding, Input } from '@angular/core';

import { OddsDisplayFormat } from '@frontend/sports/types/models/user-settings';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ILinearBetslipMessages } from '../../../../../base/models/betslip-messages';
import { IBetslipRootState } from '../../../../../base/store/state';
import { betslipResultStateSelector } from '../../../selectors';
import { IBetslipResultState } from '../../../state';

@Directive()
export default abstract class LinearResultBaseComponent {
    @Input() oddsDisplayFormat: OddsDisplayFormat;
    @Input() inColumn: boolean;

    @HostBinding('class.expanded') expanded = true;

    messages: ILinearBetslipMessages;
    resultState$: Observable<IBetslipResultState>;

    protected abstract onKeepPlacedChanged(value: boolean): void;

    protected constructor(store: Store<IBetslipRootState>) {
        this.resultState$ = store.select(betslipResultStateSelector);
    }

    toggleExpand(expanded: boolean): void {
        this.expanded = expanded;
    }
}
